import React, { useState, useRef } from 'react';
import Card from 'components_v2/common/CardV2';
import Link from 'components/Link';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import s from './ThreeWidget.scss';
import Listingheader from '../../../routes/home/components/common/Listingheader';
import RenderAds from '../../../routes/home/components/desktop/RenderAds';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';

function grenderWidgetList(wdt, ga4Type, ga4Category, lBotShown, showLoader) {
  if (
    !Array.isArray(wdt.items) ||
    (Array.isArray(wdt.items) && wdt.items.length === 0)
  )
    return null;
  const firstItem = wdt.items[0];
  return (
    <div className={`${s.storieswrap} col_l_4 col_m_4`}>
      {firstItem.tn !== 'ad' && (
        <>
          {showLoader && <LoaderSpinner />}
          {wdt.name && (
            <Listingheader
              headingname={wdt.name}
              headingLink={wdt?.path}
              ga4Type={ga4Type}
              ga4Category={ga4Category}
            />
          )}
          <div className={`${s.wrap}`}>
            <div className="widget_wrap">
              <Card
                data={firstItem}
                newga={`Click#${wdt.name}_Widget_Story_1`}
                onClick={() => {
                  analyticsWrapper(
                    'ga',
                    'send',
                    'event',
                    'WEB-IN-NHP1',
                    'Click',
                    `${wdt.name}_Widget_Story_1`,
                  );
                  if (ga4Type) {
                    analyticsWrapper('ga4', {
                      event: 'user_click',
                      type: ga4Type,
                      label: `${wdt.name.toLowerCase()}`,
                      category: ga4Category || 'story_click',
                      story_no: `1`,
                      msid: firstItem?.id,
                    });
                  }
                  if (firstItem && firstItem.tn === 'timesassist_story') {
                    analyticsWrapper('grx', 'track', 'TOIAssist_WidgetClick', {
                      slot_name: 'toi_hp_BTF2ndfold',
                      body: JSON.stringify({
                        version: '04Jul2023',
                        l_bot_shown: lBotShown,
                        bot_click:
                          firstItem.botname &&
                          typeof firstItem.botname === 'string'
                            ? firstItem.botname.toLowerCase()
                            : '',
                        type: 'redirect',
                      }),
                    });
                  }
                }}
                timesassistLeadCard={
                  firstItem && firstItem.tn === 'timesassist_story'
                }
              />
            </div>
          </div>
          <div className="row">
            {wdt.items.filter((v, i) => i > 0).map((item, index) => (
              <div className="col_l_6 bdr_right no_bdr_last linktype2">
                <Link
                  target="_blank"
                  to={item.wu}
                  newga={`Click#${wdt.name}_Widget_Story_${index + 2}`}
                  data={{
                    gaAction: 'click',
                    gaLabel: `${wdt.name}_Widget_Story_${index + 2}`,
                  }}
                  ga4Data={
                    ga4Type && [
                      {
                        event: 'user_click',
                        type: ga4Type,
                        label: `${wdt.name.toLowerCase()}`,
                        category: ga4Category || 'story_click',
                        story_no: `${index + 2}`,
                        msid: item?.id,
                      },
                    ]
                  }
                  className={
                    item && item.tn === 'timesassist_story'
                      ? s.line_clamp_2
                      : ''
                  }
                  onClick={() => {
                    analyticsWrapper(
                      'ga',
                      'send',
                      'event',
                      'WEB-IN-NHP1',
                      'Click',
                      `${wdt.name}_Widget_Story_${index + 2}`,
                    );
                    if (ga4Type) {
                      analyticsWrapper('ga4', {
                        event: 'user_click',
                        type: ga4Type,
                        label: `${wdt.name.toLowerCase()}`,
                        category: ga4Category || 'story_click',
                        story_no: `${index + 2}`,
                        msid: item?.id,
                      });
                    }

                    if (item && item.tn === 'timesassist_story') {
                      analyticsWrapper(
                        'grx',
                        'track',
                        'TOIAssist_WidgetClick',
                        {
                          slot_name: `toi_hp_BTF2ndfold`,
                          body: JSON.stringify({
                            version: '04Jul2023',
                            l_bot_shown: lBotShown,
                            bot_click:
                              item.botname && typeof item.botname === 'string'
                                ? item.botname.toLowerCase()
                                : '',
                            type: 'redirect',
                          }),
                        },
                      );
                    }
                  }}
                >
                  {item && item.tn === 'timesassist_story' ? (
                    <span>
                      {item.hl}
                      {item.slug && <sup className="newLabel">{item.slug}</sup>}
                    </span>
                  ) : (
                    item.hl
                  )}
                </Link>
                {item &&
                  item.tn === 'timesassist_story' &&
                  item.ctaText && (
                    <Link
                      target="_blank"
                      to={item.wu}
                      className="timesassistCaption"
                      onClick={() => {
                        if (ga4Type) {
                          analyticsWrapper('ga4', {
                            event: 'user_click',
                            type: ga4Type,
                            label: `${wdt.name.toLowerCase()}`,
                            category: ga4Category || 'story_click',
                            story_no: `${index + 2}`,
                            msid: item?.id,
                          });
                        }
                        if (item && item.tn === 'timesassist_story') {
                          analyticsWrapper(
                            'grx',
                            'track',
                            'TOIAssist_WidgetClick',
                            {
                              slot_name: `toi_hp_BTF2ndfold`,
                              body: JSON.stringify({
                                version: '04Jul2023',
                                l_bot_shown: lBotShown,
                                bot_click:
                                  item.botname &&
                                  typeof item.botname === 'string'
                                    ? item.botname.toLowerCase()
                                    : '',
                                type: 'redirect',
                              }),
                            },
                          );
                        }
                      }}
                    >
                      {item.ctaText}
                      {item.toiPlusLogo && (
                        <i className="timesAssistPlusIcon" />
                      )}
                    </Link>
                  )}
              </div>
            ))}
          </div>
        </>
      )}
      {firstItem?.tn === 'ad' && <RenderAds adObject={firstItem} />}
    </div>
  );
}
function ThreeWidget(props) {
  const { data, isPrime, isUserLoggedInDecided, userData } = props;
  const ga4Type = data?.ga4Type ? data?.ga4Type : '';
  const ga4Category = data?.ga4Category ? data?.ga4Category : '';

  const [widgetViewed, setWidgetViewed] = useState(false);
  const widgetViewedRef = useRef(false);

  if (data && Array.isArray(data.items) && data.items.length) {
    let lBotShown = '';
    const lastIndex = data.items.length - 1;

    const isInsertPresent =
      data.items[lastIndex] &&
      Array.isArray(data.items[lastIndex].inserts) &&
      data.items[lastIndex].inserts[0] &&
      Array.isArray(data.items[lastIndex].inserts[0].items) &&
      data.items[lastIndex].inserts[0].items.length > 2;

    const isInsertToBeShown =
      (isPrime || (isUserLoggedInDecided && userData && userData.isLoggedIn)) &&
      isInsertPresent;

    const showInsertLoader =
      isInsertPresent && !isPrime && !isUserLoggedInDecided;

    if (isInsertToBeShown) {
      const insertwidget = data.items[lastIndex].inserts[0].items;
      const botNames = insertwidget.map(
        item =>
          item.botname && typeof item.botname === 'string'
            ? item.botname.toLowerCase()
            : '',
      );
      lBotShown = botNames.join(',');
    }

    if (isInsertToBeShown && widgetViewed && !widgetViewedRef.current) {
      const bodystruct = {
        version: '04Jul2023',
        l_bot_shown: lBotShown,
        type: 'redirect',
      };

      setTimeout(() => {
        analyticsWrapper('grx', 'track', 'TOIAssist_WidgetView', {
          slot_name: 'toi_hp_BTF2ndfold',
          body: JSON.stringify(bodystruct),
        });
      }, 5000);

      widgetViewedRef.current = true;
    }
    return (
      <>
        <InViewObserver
          inViewCallback={() => {
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: `${ga4Type}`,
                category: `${ga4Category}`,
              });
            }
            setWidgetViewed(true);
          }}
        >
          {data && data.border && <InterSectionBorder border={data.border} />}
          <div
            className={`${data.wrapperClass ? s[data.wrapperClass] : ''} row`}
          >
            {data.items.map((wdt, index) => {
              if (isInsertToBeShown && index === 0) {
                wdt = data.items[lastIndex].inserts[0];
              }
              const showLoader = showInsertLoader && index === 0;
              return grenderWidgetList(
                wdt,
                ga4Type,
                ga4Category,
                lBotShown,
                showLoader,
              );
            })}
          </div>
        </InViewObserver>
      </>
    );
  }
  return null;
}

export default ThreeWidget;
